import { render, staticRenderFns } from "./User-message.vue?vue&type=template&id=961d77aa&scoped=true";
import script from "./User-message.vue?vue&type=script&lang=js";
export * from "./User-message.vue?vue&type=script&lang=js";
import style0 from "./User-message.vue?vue&type=style&index=0&id=961d77aa&prod&lang=less&scoped=true";
import style1 from "./User-message.vue?vue&type=style&index=1&id=961d77aa&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "961d77aa", null);
export default component.exports;